/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetHistoryViewer.vue?vue&type=template&id=8bcf2166&scoped=true"
import script from "./packetHistoryViewer.vue?vue&type=script&lang=js"
export * from "./packetHistoryViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcf2166",
  null
  
)

export default component.exports